import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";
import { LGNumber } from "../../atoms/Inputs/LGNumber.tsx";
import FacesSelector from "../../atoms/Inputs/FacesSelector.tsx";

export default function ProductAccJuguetesForm() {
  const { values, setFieldValue } = useFormikContext();

  // Initialize props structure for ACC_JUGUETES products
  useEffect(() => {
    if (!values.props || values.props.length === 0 || 
        !values.props.some(p => p?.key === "NC" || p?.key === "A" || p?.key === "L" || p?.key === "C" || p?.key === "S" || p?.key === "U")) {
      const props = [
        { key: "NC", value: "" }, // Numero de caras
        { key: "A", value: "" }, // Ancho
        { key: "L", value: "" }, // Largo
        { key: "C", value: "" }, // Color
        { key: "S", value: "" }, // Especificacion
        { key: "U", value: "" }, // Unidad de medida
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);

  // Validation: Ensure length is the largest dimension
  useEffect(() => {
    const width = parseFloat(values.props?.[1]?.value || 0);
    const length = parseFloat(values.props?.[2]?.value || 0);

    if (width > 0 && length > 0) {
      // Only width and length (no height)
      if (width > length) {
        // Swap width and length
        setFieldValue("props.1.value", length);
        setFieldValue("props.2.value", width);
      }
    }
  }, [values.props?.[1]?.value, values.props?.[2]?.value, setFieldValue]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FacesSelector name="props.0.value" />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.1.value"
          label="Ancho (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.2.value"
          label="Largo (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.3.value"
          label="Color"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "PRODUCT_COLOR", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.4.value"
          label="Especificación"
          as={TextField}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.5.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT" }}
          keyField="id"
        />
      </Grid>
    </Grid>
  );
}

